import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FaSearchPlus, FaTimes, FaWhatsapp } from "react-icons/fa";
import useApp from "../../hooks/useAppContext";
import "./detalhesParticipantes.css";

function celularWhatsapp(celular) {
  const digits = String(celular || "").replace(/\D/g, "");
  if (!digits) return "";
  return digits.startsWith("55") ? digits : `55${digits}`;
}

const DetalhesParticipantes = (props) => {
  const { handleImagemParticipante } = useApp();
  const [zoomAberto, setZoomAberto] = useState(false);
  const usuario = props.usuario || {};
  const src = handleImagemParticipante(usuario);
  const meta = [usuario.cargo, usuario.empresa].filter(Boolean).join(" / ");
  const waNumber = celularWhatsapp(usuario.celular);

  useEffect(() => {
    if (!zoomAberto) return undefined;

    const onKey = (event) => {
      if (event.key === "Escape") setZoomAberto(false);
    };
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [zoomAberto]);

  if (!usuario?.id && !usuario?.nome) {
    return (
      <div className="dp-card">
        <div className="dp-info">
          <div className="dp-nome">Participante não informado</div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className={`dp-card ${props.status || ""}`.trim()}>
        <button
          type="button"
          className="dp-avatar-btn"
          onClick={() => setZoomAberto(true)}
          title="Ampliar foto"
          aria-label={`Ampliar foto de ${usuario.nome || "convidado"}`}
        >
          <img src={src} alt="" className="dp-avatar" />
          <span className="dp-avatar-hint" aria-hidden>
            <FaSearchPlus size={12} />
          </span>
        </button>

        <div className="dp-dados">
          <div className="dp-info">
            <div className="dp-nome">{usuario.nome || "—"}</div>
            {meta ? <div className="dp-meta">{meta}</div> : null}
            {props.saidaLabel ? (
              <div className="dp-saida" title="Horário de saída do conteúdo">
                Saída: {props.saidaLabel}
              </div>
            ) : null}
          </div>
        </div>

        {waNumber ? (
          <a
            className="dp-whatsapp"
            title="Conversar pelo WhatsApp"
            href={`https://wa.me/${waNumber}`}
            target="_blank"
            rel="noreferrer"
            aria-label={`Abrir WhatsApp com ${usuario.nome || "convidado"}`}
            onClick={(event) => event.stopPropagation()}
          >
            <FaWhatsapp size={14} aria-hidden />
          </a>
        ) : null}
      </div>

      {zoomAberto
        ? createPortal(
            <div
              className="dp-zoom-overlay"
              role="dialog"
              aria-modal="true"
              aria-label={`Foto ampliada de ${usuario.nome || "convidado"}`}
              onClick={() => setZoomAberto(false)}
            >
              <button
                type="button"
                className="dp-zoom-close"
                onClick={() => setZoomAberto(false)}
                aria-label="Fechar zoom"
              >
                <FaTimes size={16} />
              </button>
              <figure
                className="dp-zoom-figure"
                onClick={(event) => event.stopPropagation()}
              >
                <img src={src} alt={usuario.nome || "Convidado"} />
                <figcaption>
                  <strong>{usuario.nome || "—"}</strong>
                  {meta ? <span>{meta}</span> : null}
                  {waNumber ? (
                    <a
                      className="dp-zoom-whatsapp"
                      href={`https://wa.me/${waNumber}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <FaWhatsapp size={16} aria-hidden />
                      Conversar no WhatsApp
                    </a>
                  ) : null}
                </figcaption>
              </figure>
            </div>,
            document.body
          )
        : null}
    </>
  );
};

export default DetalhesParticipantes;
